import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["currentPage", "getButtonLabel", "onChange", "pageCount", "zeroBased"];
import "core-js/modules/es.array.map.js";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import ButtonCore from 'components/ButtonCore';
import { pxToRem } from 'utils/ui/units';
var Wrapper = styled.div.withConfig({
  displayName: "SimplePagination__Wrapper",
  componentId: "sc-1i9og3w-0"
})(["display:block;text-align:center;line-height:0;"]);
var Dot = styled(ButtonCore).withConfig({
  displayName: "SimplePagination__Dot",
  componentId: "sc-1i9og3w-1"
})(["display:inline-block;vertical-align:top;width:", ";height:", ";margin:0;padding:0;overflow:hidden;text-indent:100%;font:inherit;border:0;cursor:pointer;color:inherit;background-color:transparent;outline:none;&::after{content:'';display:block;width:", ";height:", ";margin:0 auto;background-color:", ";border-radius:100px;opacity:0.4;transform:scale(0.6);transition:all 0.25s ease-in;will-change:opacity,transform;", "}&:hover::after,&:focus::after{opacity:1;}&.focus-visible{outline:none;box-shadow:0 0 0 3px ", ";border-radius:100%;}&::-moz-focus-inner{padding:0;border:0;}"], pxToRem(20), pxToRem(20), pxToRem(10), pxToRem(10), function (p) {
  return p.theme.text;
}, function (p) {
  return p.isSelected && css(["opacity:0.6;transform:scale(1);transition-timing-function:ease-out;cursor:default;"]);
}, function (p) {
  return p.theme.text;
});
function SimplePagination(props) {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var currentPage = props.currentPage,
    _props$getButtonLabel = props.getButtonLabel,
    getButtonLabel = _props$getButtonLabel === void 0 ? function (currentPage) {
      return t('pagination_current_pagePage', {
        count: currentPage
      });
    } : _props$getButtonLabel,
    onChange = props.onChange,
    pageCount = props.pageCount,
    _props$zeroBased = props.zeroBased,
    zeroBased = _props$zeroBased === void 0 ? false : _props$zeroBased,
    otherProps = _objectWithoutProperties(props, _excluded);
  if (pageCount <= 0) return null;
  var adjustedCurrentPage = zeroBased ? currentPage : currentPage - 1;
  return /*#__PURE__*/React.createElement(Wrapper, otherProps, _toConsumableArray(Array(pageCount)).map(function (x, i) {
    var isCurrent = i === adjustedCurrentPage;
    return /*#__PURE__*/React.createElement(Dot, {
      key: i,
      isSelected: isCurrent,
      onClick: function onClick() {
        return onChange(zeroBased ? i : i + 1);
      },
      "aria-label": getButtonLabel(zeroBased ? i + 1 : i),
      "aria-current": isCurrent ? 'page' : null
    });
  }));
}
export default SimplePagination;